import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput, RequiredMark } from "components";
import { required, onlyDigits } from "validators/validation";

import styles from "./businessInfo.module.scss";

const DaysToDelivery = ({ isPaperApplication }) => (
	<Row>
		<Col md={12} className="my-2">
			<div className={styles.addressTitle}>
				<p>Days to Delivery</p>
			</div>
			<Row>
				<Col lg={3}>
					<div className={styles.daysToDelivery}>
						<span className={styles.label}>
							Min
							{!isPaperApplication && <RequiredMark />}
						</span>
						<Field
							component={CustomInput}
							type="text"
							normalize={onlyDigits}
							validate={
								!isPaperApplication ? [required] : undefined
							}
							name="minDaysToDelivery"
							smSelect={12}
						/>
					</div>
				</Col>
				<Col lg={3}>
					<div className={styles.daysToDelivery}>
						<span className={styles.label}>
							Avg
							{!isPaperApplication && <RequiredMark />}
						</span>
						<Field
							component={CustomInput}
							type="text"
							normalize={onlyDigits}
							validate={
								!isPaperApplication ? [required] : undefined
							}
							name="avgDaysToDelivery"
							smSelect={12}
						/>
					</div>
				</Col>
				<Col lg={3}>
					<div className={styles.daysToDelivery}>
						<span className={styles.label}>
							Max
							{!isPaperApplication && <RequiredMark />}
						</span>
						<Field
							component={CustomInput}
							type="text"
							normalize={onlyDigits}
							validate={
								!isPaperApplication ? [required] : undefined
							}
							name="maxDaysToDelivery"
							smSelect={12}
						/>
					</div>
				</Col>
			</Row>
		</Col>
	</Row>
);

export default memo(DaysToDelivery);
